


















































































































































import Vue from 'vue';
import { $cookies } from '~/util/api';
import Join from '~/components/Join/index.vue';
import { TraceCode } from '~/util/trace';
import _ from 'lodash';
// import Sidebar from '~/components/Sidebar/index.vue';

export default Vue.extend({
  components: {
    Join,
    // Sidebar,
  },
  props:{
      serviceListAllData:{
          type: Object,
          default:()=>{
          return {
              ticketServiceList:[],
              boothServiceList:[]
          }
          }
      },
  },
   asyncData(ctx) {
  //   return {
  //     serviceListAllData:{
  //       ticketServiceList:[],
  //       boothServiceList:[]
  //     }
  //   }
  },
  data() {
    return {
      visibleLinks: false,
      showFooter: true,
      joinVisible: false,
      isSdkReady: false, // 客戶sdk初始化判断
      w: 0,
      url: '',
      name:'',
      // serviceListAll:{
      //   ticketServiceList:[],
      //   boothServiceList:[]
      // },
      lang:'',
      isShowQrcode:false,
      currentUrl:''
    };
  },
  mounted() {
    // this.init();
    const router = this.$route.path;
    this.url = router.substr(1, router.indexOf('/', 1) - 1);
  //   const obj:any = localStorage.getItem('serviceListAll')
  //   this.serviceListAll = obj ?  JSON.parse(obj) :{};
  //   console.log(this.serviceListAll,"2223")
    this.lang  = _.get(this, '$route.query.lang', "");
  },
  created() {
    const { path, name } = this.$route;
    this.name = name || ""
    // 首页和展会列表页显示友情链接
    if (path === '/' || /^\/exhibition((-\d+){7}|)\/$/.test(path)) {
      this.visibleLinks = true;
    }

    if (name === '选择支付方式') {
      this.showFooter = false;
    }
  },
  methods: {
    init() {
      window.ysf('onready', () => {
        this.isSdkReady = true;
      });
    },
    // isLogin
    shouldLogin() {
      const access_token = $cookies.get('access_token');
      // 获取不到token为未登录, 前往登录页
      if (!access_token) {
        this.$login.show();
        // this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`);
      }
      return !!access_token;
    },
    openkefu() {
      if (this.isSdkReady) {
        window.ysf('open');
      }
    },
    openWindow(path: string) {
      if (this.shouldLogin()) {
        window.open(path, '_blank');
      }
    },
    sidebarChange(e: any) {
      this.w = e;
    },
    handleApply(){
      window.open(
        `/exhibition/apply/${this.$route.params.id}.html`,
        '_blank'
      );
      window.trace?.upload({
              module: TraceCode.MO_FAIR_BOOTH,
              bizId: this.$route.params.id,
              callbackCode: TraceCode.CC_APPLY_BOOTH,
            });
    },
    mouseenterEvent(event:any,url:any){
      this.isShowQrcode = true
      this.currentUrl = url
      const target = event.target as HTMLElement;
      const rect = target.getBoundingClientRect();
      const obj = this.$refs.qrcodeDiv as HTMLElement
        obj.style.top = rect.top + 35 + 'px';
        obj.style.left = rect.left +5 + 'px';
     
    }
  },
  errorCaptured(err, vm, info) {
    if (process.client) {
      const fundebug = require('fundebug-javascript');
      fundebug.notify('ErrorCaptured', info, {
        metaData: { err, vm, info },
      });
    } else {
      console.error('ErrorCaptured', err);
    }
    return false;
  },
  head() {
    const meta = [
      {
        name: 'og:image',
        content: '//m.madkapital.com/img/logo.png',
      },
    ];
    let currentPageUrlStr = this.$route.fullPath;
    if (this.$route.fullPath.includes('/seo')) {
      currentPageUrlStr = this.$route.fullPath.split('/seo')[1];
    }

    const link = [
      {
        rel: 'canonical',
        href: `//m.madkapital.com${currentPageUrlStr}`,
      },
    ];
    const head: Record<string, any> = {};
    if (
      !/exhibition\/\d+\.html/.test(this.$route.path) &&
      !/information\/\d+\.html/.test(this.$route.path) &&
      !/information/.test(this.$route.path)
    ) {
      head.meta = meta;
    }
    if (
      !/exhibition(-\d+){7}/.test(this.$route.path) &&
      !/information(-\d+){3}/.test(this.$route.path) &&
      !/information/.test(this.$route.path)
    ) {
      head.link = link;
    }

    return head;
  },
});
